import { Badge } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";
import { useTranslate } from "@similarweb/i18n-provider";

import type { SimilarwebValueType } from "../valueType";
import { VALUE_TYPE_BADGE_COLORS, VALUE_TYPE_I18N_KEY } from "../valueType";

type TypeChipProps = {
    valueType: SimilarwebValueType;
};

export const TypeChip = ({ valueType }: TypeChipProps) => {
    const { translate } = useTranslate();
    const { bgColor, color } = VALUE_TYPE_BADGE_COLORS[valueType];

    return (
        <Flex
            inline
            alignItems="center"
            data-automation="export-table-value-type-chip"
        >
            <Badge
                type="custom"
                bgColor={bgColor}
                color={color}
                shouldTransformTextToUpperCase={false}
            >
                {translate(VALUE_TYPE_I18N_KEY[valueType])}
            </Badge>
        </Flex>
    );
};
